// import 'objectFitPolyfill';
import Carousel from '../components/Carousel';
import Collapse from '../components/Collapse';
import Wpcf7SubmitBtnHandler from '../components/Wpcf7SubmitBtnHandler';
import CountUp from '../components/CountUp';
import Menu from '../components/Menu';
import SearchBox from '../components/SearchBox';
import RelatedProjects from '../components/RelatedProjects';
import HeroOverlay from '../components/HeroOverlay';
import RelatedService from '../components/RelatedService';
import SocialWidget from '../components/SocialWidget';
import ADPJobs from '../components/ADPJobs';
import Lity from '../components/Lity';
import Modal from '../components/Modal';
import { default as Player } from '@vimeo/player';

// Content inside an [aptim-modal] dialog is present in the DOM from page load but hidden,
// so anything that measures or counts page elements has to skip it.
const outsideModals = ($elements) => $elements.not('.aptim-modal *');

export default {
  init() {
    new Carousel();
    new Collapse();
    // handles the disabling of the button while the form loads
    // we have to handle it this way because the submit button was placed elsewhere
    new Wpcf7SubmitBtnHandler();
    new CountUp();
    new Menu();
    new SearchBox();
    new RelatedProjects();
    new RelatedService();
    new SocialWidget();
    new ADPJobs();
    new Lity();
    new HeroOverlay();
    new Modal();

    this.initProjectItemHoverOnMobile();
    this.addGetInTouchButton();
    this.anchorLinkSmoothScroll();
    this.handleServicesFeaturedLinksMobileDrawer();
    this.handleServicesSpanWidth();
    this.videoFacades();
    // this.adjustIframesWidth();
    window.initLazyLoad.update();
  },

  anchorLinkSmoothScroll() {
    $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();

      if (!$($.attr(this, 'href')).length) return;

      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top,
        },
        500
      );
    });
  },

  addGetInTouchButton() {
    let btnTitle, btnClass, btnLink, clickAction = null;

    // A form inside a modal must not summon the floating CTA - the modal is in the DOM on
    // every page load, and the CTA's click handler reads .offset() off a fixed ancestor.
    const $forms = outsideModals($('.universal-form-container'));

    if ($forms.length) {
      const firstForm = $forms.first();
      const isContactForm = !!firstForm.parents('#contactForm').length;
      btnTitle = isContactForm ? 'Get in Touch' : 'Lets Go!';
      btnClass = isContactForm ? 'lg:-left-[3.75rem]' : 'lg:-left-[2.35rem]';
      btnLink = isContactForm ? '#contactForm' : '#flysheet-form';
      clickAction = isContactForm ? `onClick="gtag('event', 'click', {'event_category' : 'CTA', 'event_action' : 'Click', 'event_label' : 'Get In Touch CTA'})"` : '';
    }

    let markup = `
      <a href="${btnLink}" ${clickAction} class="aptim-floating-cta ${btnClass}">
        ${btnTitle}
      </a>
    `;

    if ($forms.length) {
      $('body').prepend(markup);
    }

    $('.aptim-floating-cta').on('click', function() {
      if ($($.attr(this, 'href')).length) return;

      $('html, body').animate(
        {
          scrollTop: $forms.first().parents('.block-container').offset().top,
        },
        500
      );
    });
  },

  initProjectItemHoverOnMobile() {
    outsideModals($('.project-item')).on('click', function () {
      if (!$(this).hasClass('hover-active')) {
        $('.project-item.hover-active').removeClass('hover-active');
        $(this).addClass('hover-active');
      } else {
        $(this).removeClass('hover-active');
      }
    });

    window.addEventListener('resize', function () {
      $('.project-item.hover-active').removeClass('hover-active');
    });
  },

  handleServicesFeaturedLinksMobileDrawer() {
    const linksDrawer = $('.js-featured-links-drawer');
    const openDrawerLink = $('.js-open-drawer');
    const closeDrawerLink = $('.js-close-drawer');

    if(linksDrawer.length > 0) {

      openDrawerLink.on('click', function() {
        openDrawerLink.addClass('hidden');
        closeDrawerLink.removeClass('hidden');
        linksDrawer.removeClass('hidden');
      })

      closeDrawerLink.on('click', function() {
        closeDrawerLink.addClass('hidden');
        openDrawerLink.removeClass('hidden');
        linksDrawer.addClass('hidden');
      })

    }

  },

  // adjusts the width of the
  handleServicesSpanWidth() {
    // getBoundingClientRect() below would read 0 inside a closed modal, and this is never
    // re-run on resize, so a bad measurement would never heal.
    const featuredLinksCol = outsideModals($('.featured-links-col'));

    if (featuredLinksCol.length) {

        featuredLinksCol.each( (idx, el) => {

          let span = $(el).find('span')

          $(span).each((idx, el) => {

            let anchor = el.querySelector('a');
            let anchorRect = anchor.getBoundingClientRect();

            $(el).css('width', `${anchorRect.width}px`)

          })

        })


    }

  },

  adjustIframesWidth () {
    $('.elementor .the-content iframe').each((index, element) => {
      let maxWidth = $(element).attr('width');
      let height = $(element).attr('height');
      $(element).css({
        maxWidth: maxWidth != '' ? maxWidth +'px' : 'auto',
        height: height != '' ? height +'px' : null,
      })
    })
  },

  videoFacades () {
    if (!document.getElementById('aptim-home-video-content')) return;
    document.getElementById('aptim-home-video-content').onload = () => {
      let iframe = $("#aptim-home-video-content");

      if (iframe.length > 0) {
        const player = new Player(iframe, { controls: false });
        window.AptimHomeVideoContent = player;
      }
    };
    $('.aptim-video-thumb').on('click', function() {
      if (window.AptimHomeVideoContent) {
        window.AptimHomeVideoContent?.play();
      } else {
        let iframe = $("#aptim-home-video-content");
  
        if (iframe.length > 0) {
          const player = new Player(iframe, { controls: false });
          window.AptimHomeVideoContent = player;
          window.AptimHomeVideoContent?.play();
        }
      }
      $(this).hide();
    });
  },
};
